import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useTheme, type ThemePreference } from "../context/ThemeContext";

type Props = {
  onAuthClick: () => void;
};

export function NavBar({ onAuthClick }: Props) {
  const { user, logout } = useAuth();
  const { themePreference, setThemePreference } = useTheme();
  const themeOptions: { key: ThemePreference; label: string }[] = [
    { key: "system", label: "Auto" },
    { key: "light", label: "Light" },
    { key: "dark", label: "Dark" },
  ];

  return (
    <>
      <div className="theme-switch" role="group" aria-label="Theme preference">
        {themeOptions.map((option) => (
          <button
            key={option.key}
            type="button"
            className={`theme-switch-option${themePreference === option.key ? " active" : ""}`}
            onClick={() => setThemePreference(option.key)}
            aria-pressed={themePreference === option.key}
          >
            {option.label}
          </button>
        ))}
      </div>

      {user ? (
        <div className="nav-handle">
          <NavLink to={`/@${user.handle}`} className="nav-handle-link">
            @{user.handle}
          </NavLink>
          <button type="button" className="nav-signout" onClick={() => void logout()}>
            Sign out
          </button>
        </div>
      ) : (
        <button type="button" className="nav-auth-btn" onClick={onAuthClick}>
          ◎
        </button>
      )}

      <nav className="nav-bar">
        <NavLink to="/" className={({ isActive }) => `nav-item${isActive ? " active" : ""}`}>
          <span className="nav-icon">⌂</span>
          <span>Home</span>
        </NavLink>

        <NavLink to="/map" className={({ isActive }) => `nav-item${isActive ? " active" : ""}`}>
          <span className="nav-icon">🧭</span>
          <span>Explore</span>
        </NavLink>

        <NavLink to="/buzz" className={({ isActive }) => `nav-item${isActive ? " active" : ""}`}>
          <span className="nav-icon">⚡</span>
          <span>Live</span>
        </NavLink>

        <NavLink to="/leaderboard" className={({ isActive }) => `nav-item${isActive ? " active" : ""}`}>
          <span className="nav-icon">🏆</span>
          <span>Leaders</span>
        </NavLink>
      </nav>
    </>
  );
}
